import { zodResolver } from '@hookform/resolvers/zod'
import { createFileRoute } from '@tanstack/react-router'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import Breadcrumbs from '@/containers/breadcrumbs'

import { Button } from '@/components/button'
import { Card, CardContent, CardHeader } from '@/components/card'
import Content from '@/components/content'
import { Form } from '@/components/form'
import FormInput from '@/components/form/formInput'
import FormSelect from '@/components/form/formSelect'
import PageHeader from '@/components/pageHeader'

import { useSetBreadcrumbs } from '@/state/breadcrumbs'

import PlaygroundNavigation from '../-components/playgroundNavigation'

export const Route = createFileRoute('/_authed/$client_code/playground/forms/')({
    component: PlaygroundForms,
})

function PlaygroundForms() {
    const { client_code } = Route.useParams()
    useSetBreadcrumbs([
        {
            to: '/$client_code/playground',
            text: 'Playground',
            params: { client_code },
        },
        'seperator',
        {
            to: '/$client_code/playground/forms',
            text: 'Forms',
            params: { client_code },
        },
    ])

    const timezones = ['Pacific/Auckland', 'Australia/Sydney'] as const
    const formSchema = z.object({
        email: z.string().email(),
        password: z.string().min(8),
        timezone: z.enum(timezones),
    })

    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        mode: 'onBlur',
    })

    return (
        <>
            <Breadcrumbs />
            <Content>
                <PageHeader title="Forms" />
                <PlaygroundNavigation active="forms" />

                <h3 className="my-4">Simple form</h3>
                <Card className="w-96">
                    <CardHeader>Create an account</CardHeader>
                    <CardContent>
                        <Form {...form}>
                            <form onSubmit={console.log} className="space-y-4 pt-4">
                                <FormInput
                                    control={form.control}
                                    name="email"
                                    placeholder="you@example.com"
                                    label={<>Email</>}
                                />
                                <FormInput control={form.control} name="password" type="password" label={<>Email</>} />
                                <FormSelect
                                    control={form.control}
                                    name="timezone"
                                    label={<>Timezone</>}
                                    placeholder="Timezone"
                                    options={
                                        timezones.map(t => ({
                                            value: t,
                                            label: t,
                                        })) || []
                                    }
                                />
                                <Button type="submit" disabled={!form.formState.isValid}>
                                    Create
                                </Button>
                            </form>
                        </Form>
                    </CardContent>
                </Card>
            </Content>
        </>
    )
}
